import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BaseIconComponent } from '../iconbase';

@Component({
  selector: 'sof-times-icon',
  templateUrl: '../icon.template.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimesComponent extends BaseIconComponent {
  constructor() {
    super('times');
  }
}
